module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 56
// module chunks = 7